import { ServiceIdsForMember } from '@/types/seekerCC';
import { TrafficSource } from '@/types/seeker';
import useFeatureFlag from '@/components/hooks/useFeatureFlag';
import { CLIENT_FEATURE_FLAGS } from '@/constants';
import { useSeekerCCState, useSeekerState } from '@/components/AppState';

function useIsCCSkipCareKind() {
  const { source } = useSeekerState();
  const { czenServiceIdForMember } = useSeekerCCState();
  const seekerCCSkipCareKindFlag = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.SEEKER_CC_SKIP_CARE_KIND_SEO
  );
  const isCCSubService =
    czenServiceIdForMember === ServiceIdsForMember.nanny ||
    czenServiceIdForMember === ServiceIdsForMember.babysitter;

  const isCCSkipCareKindEligible = source === TrafficSource.SEO && isCCSubService;
  const isCCSkipCareKind = isCCSkipCareKindEligible && seekerCCSkipCareKindFlag?.value === 2;

  return {
    seekerCCSkipCareKindFlag,
    isCCSkipCareKindEligible,
    isCCSkipCareKind,
  };
}

export default useIsCCSkipCareKind;
